import React, { Component } from 'react';
import Modal from '../Modal/Modal';

/**
 * Higher-Order Component that wraps family member components
 * Provides shared functionality: age management, modal controls, and member details
 * @param {React.Component} Member - The component to be wrapped
 * @param {Object} memberDetails - Specific details for the family member
 * @returns {React.Component} Enhanced component with shared functionality
 */
const Family = (Member, memberDetails) => {
    class NewMember extends Component {
        constructor(props) {
            super(props);

            this.state = {
                age: 0,
                isShowing: false,
                mydetail: memberDetails
            };
        }

        /**
         * Increments the age of the family member
         */
        incrementAge = () => {
            this.setState(prevState => ({
                age: prevState.age + 1
            }));
        }

        /**
         * Opens the modal dialog
         */
        openModalHandler = () => {
            this.setState({
                isShowing: true
            });
            // Prevent body scroll
            document.body.classList.add('modal-open');
        }

        /**
         * Closes the modal dialog
         */
        closeModalHandler = () => {
            this.setState({
                isShowing: false
            });
            // Restore body scroll
            document.body.classList.remove('modal-open');
        }

        /**
         * Cleanup when component unmounts
         */
        componentWillUnmount() {
            // Ensure body scroll is restored
            document.body.classList.remove('modal-open');
        }


        render() {
            return (
                <>
                    {/* Modal backdrop */}
                    {this.state.isShowing && (
                        <div
                            onClick={this.closeModalHandler}
                            className="back-shed"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Escape' && this.closeModalHandler()}
                            aria-label="Close modal"
                        />
                    )}

                    {/* Modal component */}
                    <Modal
                        className="modal"
                        show={this.state.isShowing}
                        close={this.closeModalHandler}
                        mydetail={this.state.mydetail}
                        gender="Male"
                        incrementAge={this.incrementAge}
                        age={this.state.age}
                    />

                    {/* Main content area */}
                    <div className="">
                        {/* Wrapped component with enhanced props */}
                        <Member
                            mydetail={this.state.mydetail}
                            gender="Male"
                            incrementAge={this.incrementAge}
                            age={this.state.age}
                            openModal={this.openModalHandler}
                        />

                        <button
                            className="open-modal-btn"
                            onClick={this.openModalHandler}
                            type="button"
                            aria-label="Open modal for detailed view"
                        >
                            <i className="fas fa-expand-alt mr-2"></i>
                            View Details
                        </button>
                    </div>
                </>
            );
        }
    }

    // Set display name for debugging
    NewMember.displayName = `Family(${Member.displayName || Member.name || 'Component'})`;

    return NewMember;
};

export default Family;
